import Vue from 'vue'
import App from './App.vue'
// 1. 导入路由实例（确保路径正确）
import router from './router'
// 引入 Element UI
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

// 关闭 Vue 生产提示
Vue.config.productionTip = false
// 关闭 Vue 严格模式（默认已关，显式声明更稳妥）
Vue.config.silent = true 
// 关闭 Vue 运行时警告（开发阶段可选）
Vue.config.warnHandler = () => {}

Vue.use(ElementUI)

Vue.config.productionTip = false

new Vue({
    router, // 路由注入（/* eslint-disable-line no-unused-vars */ 可加这行注释忽略）
    render: h => h(App),
}).$mount('#app')
